import styled from 'styled-components';
const Separator = styled.div.withConfig({
  displayName: "Separator",
  componentId: "sc-1eb4zkk-0"
})(["display:flex;width:100%;justify-content:center;align-items:center;text-align:center;color:#cbd6e2;border-top:2px solid #cbd6e2;"]);
export default Separator;